import {Routes} from '@angular/router';
import {HairdressersComponent} from './hairdressers.component';

export const hairdressersRoutes: Routes = [
  {
    path: '',
    component: HairdressersComponent
  }
];
